<template>
  <div>
	 <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Add User</strong>
          </CCardHeader>
          <CCardBody class="profile-details-main">
			<CForm class="formData">
            <CRow>
				<CCol sm="6">
                <CInput
                  label="User ID"
                  placeholder="User ID" type="number" name="User_Id"
                />
              </CCol>			  
              <CCol sm="6">
                <CInput
                  label="First Name"
                  placeholder="First Name" name="FirstName"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="Last Name"
                  placeholder="Last Name" name="LastName"
                />
              </CCol>
              <CCol sm="6">
                <CInput
                  label="User Name"
                  placeholder="User Name" name="UserName"
                />
              </CCol>
				      <CCol sm="6">
                <CInput
                  label="User Email"
                  placeholder="User Email" type="email" name="UserEmail"
                />
              </CCol>		
              <CCol sm="6">
                <CInput
                  label="Mobile Number"
                  placeholder="Mobile Number" name="MobileNo"
                />
              </CCol>			  
              <CCol sm="12" class="form-group">
                <label class="m-0 col-fonts-black mb-2">Assign Role</label>
                <!---<v-select :options="physicalOptions" placeholder="Select Role"></v-select>-->
				<select class="v-select" id="rollselect">
					<option  v-for="role in roleOptions" :value="role.Role_Id">{{role.RoleName}}</option> 
				</select>  
                </CCol>
				      <!--<CCol sm="6">
                <CInput
                  label="Department"
                  placeholder="Department"
                />
              </CCol>-->
            
            

              <CCol sm="11">
                <div class="form-group add-user-profile-upload">
                  <label class="col-fonts-black mb-2">File custom input</label>
                  <CInputFile id="fileupload" @change="uploadImage" name="photo" accept="image/*"
                horizontal
                custom
              />
              </div>
               </CCol>

                <CCol sm="1">
                  <div class="c-avatar profile-image">
                  <img src="" id="imageSrc" class="c-avatar-img" alt="">
				  <CInput hidden name="imageblob" id="imageblob" value=""/>
                </div>
                </CCol>

               </CRow>
              <!--<CRow>
              <CCol sm="12">
                <CInput
                  label="Designation/Profession"
                  placeholder="Designation"
                />
              </CCol>							 
            </CRow>-->
            <CRow>
              <CCol sm="6">
                <CInput
                  label="Password"
                  placeholder="Password" name="Password"
                />
              </CCol>
				<CCol sm="6">
                <CInput
                  label="Confirm Password"
                  placeholder="Confirm Password" name="Repassword"
                />
              </CCol>			  
            </CRow>
			 <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18" @click="submit()">Add</button>
			</CCol>
			 
            </CRow>
			<CRow>
			<CCol col="12" class="text-left">
				<p style="color:red;" id="reponse_error"></p>
			</CCol>
		  </CRow>
			</CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: 'Add_users',
  data () {
    return {
	  isLoading: false,
      setSelected:"",
      selected: [], // Must be an array reference!
      avatar: [ 'img/avatars/1.jpg' ],
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],     
	  siteOptions : [],
	  roleOptions : [],
      physicalOptions : ['Sales Executive','Customer'],
      customerOptions: [],
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],	
	  oldest_os_amt:0,
	  oldest_days:0,
	  invoice_number:0,
	  outstanding_amt:0,
	  imageSrc:"",
      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],
		IPAddress:"172.16.2.30",
		Latitude:"21.2354158452",
		Longitude:"72.89745852",
    }
  },
  mounted () {
	$('.counterDiv').hide();
	$('.otherOptions').hide();	
	var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));
	var token=localStorage.getItem("auth");
	var requestInfo = {		
	Token:token,
	Session_User_Id:Session_User_Id,
	};
	var data = JSON.stringify(requestInfo);							
		var config = {
		  method: 'post',
		  url: apiURL+'ManageRole/GetRolesList',
		  headers: { 
			'Content-Type': 'application/json'
		  },
		  data : data
	};
	var self =this;
	var rollsData=[];
	this.isLoading =true;
	axios(config)
	.then((result) => {	
		this.isLoading = false;		
		if(result.data.status_code==200){
			var obj=result.data.response;			
			this.roleOptions=obj;								
		}else{								
			this.$swal.fire({
			  icon: 'error',
			  title: 'Oops...',
			  text: result.data.message		 
			})
		}
	  
	})
	.catch((error) => {	
		this.isLoading = false;			
		this.$swal.fire({
		  icon: 'error',
		  title: 'Oops...',
		  text: 'Something went wrong!'		 
		})
	});
	
	fetch('https://api.ipify.org?format=json')
	.then(x => x.json())
	.then(({ ip }) => {
		this.IPAddress = ip;
		//console.log(this.IPAddress);
	});
	
	const success = (position) => {
		this.latitude  = position.coords.latitude;
		this.longitude = position.coords.longitude;
		//console.log(this.latitude+' '+this.longitude);
	};

	const error = (err) => {
		console.log(error)
	};

	// This will open permission popup
	navigator.geolocation.getCurrentPosition(success, error);
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){
		//console.log('call');
		this.$router.push({path:'manage_users'})
	},
	uploadImage: function() {    
      var file = document
        .querySelector('input[type=file]')
        .files[0];
      var reader = new FileReader();
      reader.onload = function(e) {		
        this.imageSrc = e.target.result;		
		$('#imageblob').val(this.imageSrc);
		$('#imageSrc').attr('src',this.imageSrc);
      };
      reader.onerror = function(error) {
        alert(error);
      };
      reader.readAsDataURL(file);      
    },
	submit(){
				
		var Session_User_Id=JSON.parse(localStorage.getItem("User_Id"));		
		var User_Id=$('input[name=User_Id]').val();			
		if (User_Id.search(/^\d*[.]?\d*$/) == -1) {
			this.$swal('User ID should be numbered');
			return false;
		}else if(User_Id==''){
			this.$swal('User ID should be required');
			return false;
		}
		var FirstName=$('input[name=FirstName]').val();
		if(FirstName==''){
			this.$swal('First Name should be required');
			return false;
		}
		var LastName=$('input[name=LastName]').val();
		if(LastName==''){
			this.$swal('Last Name should be required');
			return false;
		}
		var UserName=$('input[name=UserName]').val();
		if(UserName==''){
			this.$swal('Username should be required');
			return false;
		}
		var UserEmail=$('input[name=UserEmail]').val();	
		if(UserEmail==''){
			this.$swal('User Email should be required');
			return false;
		}else if (UserEmail.search(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/) == -1) {
			this.$swal('Invalid email format');			
			return false;
		}
		var MobileNo=$('input[name=MobileNo]').val();
		if(MobileNo==''){
			this.$swal('Mobile No should be required');
			return false;
		}
		var Password=$('input[name=Password]').val();
		if(Password==''){
			this.$swal('Password should be required');
			return false;
		}
		var Repassword=$('input[name=Repassword]').val();
		if(Repassword==''){
			this.$swal('Confirm Password should be required');
			return false;
		}
		
		var Role_Id=$('#rollselect').val();
		var user=JSON.parse(localStorage.getItem("user"));
		//var IPAddress=user[0].IPAddress;		
		//var Latitude=user[0].Latitude;
		//var Longitude=user[0].Longitude;
		var imageblob = $('#imageblob').val();		
		var strblob = imageblob.split(',');
		var imageblob = strblob[1];
		var token=localStorage.getItem("auth");
		var IPAddress=this.IPAddress;
		var Latitude=this.Latitude;
		var Longitude=this.Longitude;
		
		var requestInfo = {
		User_Id: User_Id,
		Role_Id: Role_Id,
		FirstName: FirstName,
		LastName:LastName,
		UserName: UserName,
		UserEmail:UserEmail,
		MobileNo:MobileNo,
		Password:Password,
		Status:'Active',
		ProfileImage:imageblob,
		IPAddress:IPAddress,
		Latitude:Latitude,
		Longitude:Longitude,
		Token:token,
		Session_User_Id:Session_User_Id,
		};
		//console.log(requestInfo);		
		//return false;
		var self =this;
		if(Password==Repassword){
			var data = JSON.stringify(requestInfo);								
				var config = {
				  method: 'post',
				  url: apiURL+'ManageUsers/AddNewUser',
				  headers: { 
					'Content-Type': 'application/json'
				  },
				  data : data
			};
			this.isLoading = true;
			axios(config)
			.then((result) => {	
				this.isLoading = false;		
				if(result.data.status_code==200){		
					//console.log(result);				
					//$('#reponse_error').html(result.data.message);
					this.$swal.fire(
						'Saved',
						result.data.message,
						'success'
					);
					//$('.formData')[0].reset();
				}else{				
					//$('#reponse_error').html(result.data.message);
					//swal("Cancelled", "Your imaginary file is safe :)", "error");
					this.$swal.fire({
					  icon: 'error',
					  title: 'Oops...',
					  text: result.data.message		 
					})
				}
			  
			})
			.catch((error) => {
				this.isLoading = false;
				//var errorObject=JSON.stringify(error.response.data.errors);			
				//console.log(errorObject);		   
				this.$swal.fire({
				  icon: 'error',
				  title: 'Oops...',
				  text: 'Something went wrong!'		 
				})
			});
		}else{
			this.isLoading = false;
			//$('#reponse_error').html("Password Did't Matche..!");
			this.$swal("Password Did't Matche..!");
		}
	}
  }
}
</script>
